import script from "./fileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUpload.vue?vue&type=script&setup=true&lang=js"

import "./fileUpload.vue?vue&type=style&index=0&id=1a32345c&lang=scss"

const __exports__ = script;

export default __exports__